import { FlexCol } from '../../../common/frontend/components/flex-col/flex-col.js'
import { FlexRow } from '../../../common/frontend/components/flex-row/flex-row.js'
import { Button, ButtonProps } from '../../components/button/button.js'
import { TextField, TextFieldProps } from '../../components/forms/text-field/text-field.js'
import { Toggle, ToggleProps } from '../../components/forms/toggle/toggle.js'

export type InfoRow = {
    id: number
    title: string
    content: string
    link?: string
    isLink: boolean
}

export interface SignatureInfoRowsProps {
    titleFieldProps: TextFieldProps
    contentFieldProps: TextFieldProps
    linkFieldProps: TextFieldProps
    toggleProps: ToggleProps
    removeButtonProps: ButtonProps
    isLinkLabel: string
    rows: InfoRow[]
    onRowsChange: (rows: InfoRow[]) => void
}

export const SignatureInfoRows = (props: SignatureInfoRowsProps) => {
    const updateRow = (id: number, patch: Partial<InfoRow>) => {
        const updatedRows = props.rows.map((r) => (r.id === id ? { ...r, ...patch } : r))
        props.onRowsChange(updatedRows)
    }

    const removeRow = (id: number) => {
        const updatedRows = props.rows.filter((r) => r.id !== id)
        props.onRowsChange(updatedRows)
    }

    return (
        <>
            {props.rows.map((row) => (
                <FlexCol key={row.id} gap={1}>
                    <FlexRow className="signature-creation__custom-row" gap={2}>
                        <TextField
                            label={props.titleFieldProps.label}
                            isRequired={true}
                            value={row.title}
                            onChange={(value: string) => updateRow(row.id, { title: value })}
                            inputProps={{ maxLength: 200 }}
                        />

                        <TextField
                            label={props.contentFieldProps.label}
                            isRequired={true}
                            value={row.content}
                            onChange={(value: string) => updateRow(row.id, { content: value })}
                            inputProps={{ maxLength: 200 }}
                        />
                    </FlexRow>

                    {row.isLink && (
                        <FlexRow gap={2} className="signature-creation__link-row">
                            <TextField
                                label={props.linkFieldProps.label}
                                value={row.link}
                                onChange={(value: string) => updateRow(row.id, { link: value })}
                                inputProps={{ maxLength: 500 }}
                            />
                        </FlexRow>
                    )}

                    <FlexRow gap={2} className="signature-creation__action-row">
                        <span>{props.isLinkLabel} </span>
                        <label className="signature-creation__islink">
                            <Toggle
                                value={row.isLink}
                                offText={props.toggleProps?.offText}
                                onText={props.toggleProps?.onText}
                                onChange={(nextValue: boolean | undefined) =>
                                    updateRow(row.id, { isLink: nextValue ?? false })
                                }
                            />
                        </label>

                        <Button
                            text={props.removeButtonProps.text}
                            size={props.removeButtonProps.size}
                            variant="alert"
                            onClick={() => removeRow(row.id)}
                        />
                    </FlexRow>
                </FlexCol>
            ))}
        </>
    )
}
